import { useState } from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import KeyboardArrowUpRounded from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";

/**
 * Collapsible "show original" footer for Trade/Spread cards.
 *
 * The card surfaces only the extracted field values; any caveat prose inside
 * the absorbed span — "example strikes", "(assumed 2-week expiry)", "use live
 * quote", placeholder economics — is otherwise invisible to the user (SPY
 * bull-put SSE sample). This keeps the LLM's full text one tap away so the
 * card never hides information it can't represent.
 */
const CardSourceToggle = ({ raw }: { raw?: string }) => {
  const [open, setOpen] = useState(false);
  if (!raw?.trim()) return null;
  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        className="flex items-center gap-0.5 text-xs font-medium text-token-text-secondary hover:text-token-text-primary"
      >
        {open ? "Hide original text" : "Show original text"}
        {open
          ? <KeyboardArrowUpRounded className="!h-4 !w-4" />
          : <KeyboardArrowDownRounded className="!h-4 !w-4" />}
      </button>
      {open && (
        <div className="mt-2 rounded-lg border border-mui-black-12 bg-black/[0.02] px-3 py-2 text-sm text-token-text-secondary dark:border-mui-white-12 dark:bg-white/[0.04]">
          <ReactMarkdown remarkPlugins={[gfm]} className="markdown-body">
            {raw}
          </ReactMarkdown>
        </div>
      )}
    </div>
  );
};

export default CardSourceToggle;
